export default "__VITE_ASSET__iCE9b2k3__"